var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"ew-footer",class:{ 'ew-footer--visible': _vm.isAtBottom }},[_c('p',{staticClass:"ew-footer-copy mb-0 text-center text-truncate"},[_vm._v("\n    © "+_vm._s(_vm.currentYear)+" SackTech Logistics. Todos los derechos reservados.\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f3da3df","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppFooter.vue
// module id = null
// module chunks = 